import { Link } from 'react-router-dom';

import { cn } from '@/lib/cn';

export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={cn('h-8 w-8', className)} aria-hidden="true">
      <defs>
        <linearGradient id="kha-logo" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="rgb(var(--kha-tech))" />
          <stop offset="100%" stopColor="rgb(var(--kha-ai))" />
        </linearGradient>
      </defs>
      <rect width="48" height="48" rx="11" className="fill-surface-2" />
      <path
        d="M12 12v24M12 24l10-12M12 24l10 12"
        stroke="url(#kha-logo)"
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M28 36V12M38 36V12M28 24h10"
        stroke="url(#kha-logo)"
        strokeWidth="3.4"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

export function BrandLink({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 rounded-lg" aria-label="KH AI Academy, accueil">
      <Logo />
      {!compact && (
        <span className="leading-tight">
          <span className="block text-sm font-extrabold tracking-tight text-fg">
            KH <span className="kha-gradient-text">AI ACADEMY</span>
          </span>
          <span className="block text-2xs text-faint">DevOps · MLOps · Agents IA</span>
        </span>
      )}
    </Link>
  );
}

export function Signature({ className }: { className?: string }) {
  return (
    <p className={cn('text-xs text-faint', className)}>
      <span className="font-semibold text-muted">Khlifi Houcem</span> — Formateur DevSecOps et Cloud
    </p>
  );
}
